module.exports = __webpack_public_path__ + "static/fonts/BMDOHYEON.9dbe9ac.ttf";